var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0657D727-46CB-42AD-8C69-F5DF91FA1C6C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Products",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Admin---Home-Products",
    transform: "translate(-1288.000000, -255.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete-BTN",
    transform: "translate(1272.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-3",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 L10.5,0 C10.7761424,-5.07265313e-17 11,0.223857625 11,0.5 C11,0.776142375 10.7761424,1 10.5,1 L5.5,1 C5.22385763,1 5,0.776142375 5,0.5 C5,0.223857625 5.22385763,5.07265313e-17 5.5,0 Z M15.5,2 C15.7761424,2 16,2.22385763 16,2.5 C16,2.77614237 15.7761424,3 15.5,3 L14.5,3 L14.5,15 C14.5,15.5522847 14.0522847,16 13.5,16 L2.5,16 C1.94771525,16 1.5,15.5522847 1.5,15 L1.5,3 L0.5,3 C0.223857625,3 3.38176876e-17,2.77614237 0,2.5 C-3.38176876e-17,2.22385763 0.223857625,2 0.5,2 L15.5,2 Z M13.5,3 L2.5,3 L2.5,15 L13.5,15 L13.5,3 Z M6,5 C6.27614237,5 6.5,5.22385763 6.5,5.5 L6.5,12.5 C6.5,12.7761424 6.27614237,13 6,13 C5.72385763,13 5.5,12.7761424 5.5,12.5 L5.5,5.5 C5.5,5.22385763 5.72385763,5 6,5 Z M10,5 C10.2761424,5 10.5,5.22385763 10.5,5.5 L10.5,12.5 C10.5,12.7761424 10.2761424,13 10,13 C9.72385763,13 9.5,12.7761424 9.5,12.5 L9.5,5.5 C9.5,5.22385763 9.72385763,5 10,5 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.59612f26.svg";
export { ForwardRef as ReactComponent };